/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Field_Client_SecretInputs */



/**
* | output |
* | --- |
* | "Client secret (optional)" |
*
* @param {Mcp_Servers_Field_Client_SecretInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_field_client_secret = /** @type {((inputs?: Mcp_Servers_Field_Client_SecretInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Field_Client_SecretInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Client-Secret (optional)")
	return /** @type {LocalizedString} */ ("Client secret (optional)")
});